import { render, staticRenderFns } from "./outlookTagManagement.vue?vue&type=template&id=2749f042&scoped=true"
import script from "./outlookTagManagement.vue?vue&type=script&lang=js"
export * from "./outlookTagManagement.vue?vue&type=script&lang=js"
import style0 from "./outlookTagManagement.vue?vue&type=style&index=0&id=2749f042&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2749f042",
  null
  
)

export default component.exports